// extracted by mini-css-extract-plugin
module.exports = {"bannerTextWidth":"treatment_bannerTextWidth__1qd1w","hiddenDesc":"treatment_hiddenDesc__2zEAC","pusherDiv":"treatment_pusherDiv__uWFiM"};